;(function() {
  'use strict'

  pollingRun.$inject = ["pollingService", "$window", "$interval"];
  angular
    .module('core.services')
    .run(pollingRun)
    .factory('pollingService', pollingService)

  // --------------------

  /* @ngInject */
  function pollingRun(pollingService, $window, $interval) {
    var idle
    var timeout
    var maxIdle = 60 // max idle time in seconds

    // events to watch
    var events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress',
    ]

    checkIdle()

    timeout = $interval(checkIdle, maxIdle * 1000)

    function enablePolling() {
      pollingService.enable()
    }

    function disablePolling() {
      pollingService.disable()
    }

    function resetIdle() {
      angular.element($window).off(events.join(' '), resetIdle)
      idle = false
    }

    function checkIdle() {
      if (idle) {
        disablePolling()
      } else {
        idle = true
        enablePolling()
      }
      angular.element($window).on(events.join(' '), resetIdle)
    }
  }

  /* @ngInject */
  function pollingService() {
    var pollingEnabled = true

    return {
      isEnabled: isEnabled,
      enable: enable,
      disable: disable,
    }

    function isEnabled() {
      return pollingEnabled
    }

    function enable() {
      pollingEnabled = true
    }

    function disable() {
      pollingEnabled = false
    }
  }
})()
